import { useNavigate } from 'react-router-dom'
import { PlaneTakeoff, CalendarPlus, Map } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAddPlaneWizardStore } from '@/stores/addPlaneWizardStore'
import { FlightAwareSyncButton } from './FlightAwareSyncButton'

interface QuickActionsBarProps {
  locationSlug: string | null
  locationId: string | null
  onAddSchedule: () => void
}

export function QuickActionsBar({
  locationSlug,
  locationId,
  onAddSchedule,
}: QuickActionsBarProps) {
  const navigate = useNavigate()
  const openWizard = useAddPlaneWizardStore((s) => s.openWizard)

  const handleWalkIn = () => {
    openWizard({ source: 'ramp', locationId: locationId ?? undefined })
  }

  const handleOpenRamp = () => {
    if (locationSlug) {
      navigate(`/${locationSlug}/ramp`)
    }
  }

  return (
    <div className="border-t bg-background/95 backdrop-blur-sm">
      <div className="flex items-center justify-between gap-2 px-4 py-3">
        <div className="flex items-center gap-2">
          <Button size="sm" onClick={handleWalkIn}>
            <PlaneTakeoff className="h-4 w-4 mr-1.5" />
            Walk-In
          </Button>

          <Button variant="outline" size="sm" onClick={onAddSchedule}>
            <CalendarPlus className="h-4 w-4 mr-1.5" />
            Add Schedule
          </Button>

          <FlightAwareSyncButton locationId={locationId} />
        </div>

        <Button variant="ghost" size="sm" onClick={handleOpenRamp}>
          <Map className="h-4 w-4 mr-1.5" />
          Open Ramp
        </Button>
      </div>
    </div>
  )
}
